import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { ReactComponent as Threads } from '../../images/threads.svg';

interface ThreadsIconProps extends SvgIconProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const ThreadsIcon = (props: ThreadsIconProps) => (
  <SvgIcon
    {...props}
    component={Threads}
    sx={{
      ...(props?.size === 'sm'
        ? { width: '16px', height: '16px' }
        : props?.size === 'lg'
        ? { width: '32px', height: '32px' }
        : props?.size === 'xl'
        ? { width: '40px', height: '40px' }
        : ''),
    }}
  />
);

export default ThreadsIcon;
